import baseApi from "../utils/ApiUtils";

export const settingApi = (method, payload = null, params = null) => {
  return baseApi(`/settings/`, method, params, payload).then((response) => {
    return response.data;
  });
};

export const settingAction = (method, id, payload = null, params = null) => {
  return baseApi(`/settings/${id}/`, method, params, payload).then((response) => {
    return response.data;
  });
};

export const ticketsApi = (method, payload = null, params = null) => {
  return baseApi(`/tickets/`, method, params, payload).then((response) => {
    return response.data;
  });
};

export const ticketsAction = (method, id, payload = null, params = null) => {
  return baseApi(`/tickets/${id}/`, method, params, payload).then((response) => {
    return response.data;
  });
};

export const ticketsActivityLog = (method, id, payload = null, params = null) => {
  return baseApi(`/tickets/${id}/activity_logs/`, method, params, payload).then((response) => {
    return response.data;
  });
};

export const ticketsTransition = (method, id, payload = null, params = null) => {
  return baseApi(`/tickets/${id}/transition/`, method, params, payload).then((response) => {
    return response.data;
  });
};

export const ticketsType = (method, payload = null, params = null, id = null) => {
  const url = id ? `/masters/ticket_fees/${id}/` : "/masters/ticket_fees/";
  return baseApi(url, method, params, payload).then((response) => {
    return response.data;
  });
};

export const exhibitions = (method, payload = null, params = null, id = null) => {
  const url = id ? `/exhibitions/${id}/` : '/exhibitions/';
  return baseApi(url, method, params, payload).then((response) => {
    return response.data;
  });
};

export const visitorTypes = (method, payload = null, params = null, id = null) => {
  const url = id ? `/masters/visitor_types/${id}/` : "/masters/visitor_types/";
  return baseApi(url, method, params, payload).then((response) => {
    return response.data;
  });
};

export const museumExhibitionTypes = (method, payload = null, params = null, id = null) => {
  const url = id ? `/masters/museum_exhibition_types/${id}/` : "/masters/museum_exhibition_types/";
  return baseApi(url, method, params, payload).then((response) => {
    return response.data;
  });
};

export const discounts = (method, payload = null, params = null, id = null) => {
  const url = id ? `/discounts/${id}/` : '/discounts/';
  return baseApi(url, method, params, payload).then((response) => {
    return response.data;
  });
};

export const guides = (method, payload = null, params = null, id = null) => {
  const url = id ? `/guides/${id}/` : '/guides/';
  return baseApi(url, method, params, payload).then((response) => {
    return response.data;
  });
};

export const getTourGuideByCid = (cid) => {
  return baseApi(`/tour_guides/${cid}/`, 'get').then((response) => {
    return response.data;
  });
};

export const getTourOperatorByLicense = (licenseNo) => {
  return baseApi(`/tour_operators/${licenseNo}/`, 'get').then((response) => {
    return response.data;
  });
};

export const getTicketDiscounts = (params = null) => {
  return baseApi(`/masters/ticket_discounts/`, 'get', params).then((response) => {
    return response.data;
  });
};

export const getExhibitions = (params = null) => {
  return baseApi(`/exhibitions/`, 'get', params).then((response) => {
    return response.data;
  });
};
